import { useQuery } from '@tanstack/react-query';

import { RequestConfig } from '~/common/services/requests';
import { useRequestConstructor } from '../../../../hooks/useRequestConstructor';
import { unwrapPaginatedResponseDataAs } from '../../../../logic/unwrapPaginatedResponseDataAs';
import { APPLICATION_BASE_PATH } from '../../constants/applicationBasePath';
import { getApplicationUncategorizedDocs } from '../../requests/getApplicationUncategorizedDocs';

export const useApplicationUncategorizedDocs = (
  uuid: string,
  definitionName: string,
  params?: RequestConfig['params'],
  options?: {
    enabled?: boolean;
    refetchOnWindowFocus?: boolean;
    keepPreviousData?: boolean;
    staleTime?: number;
  },
) => {
  const { constructGet } = useRequestConstructor();

  const { data, refetch, ...rest } = useQuery<
    Awaited<ReturnType<typeof getApplicationUncategorizedDocs>>
  >({
    queryKey: [APPLICATION_BASE_PATH, uuid, 'docs-uncategorized', params],
    queryFn: () =>
      getApplicationUncategorizedDocs(
        constructGet,
        uuid,
        definitionName,
        params,
      ),
    enabled: Boolean(uuid) && (options?.enabled ?? true),
    keepPreviousData: options?.keepPreviousData ?? true,
    refetchOnWindowFocus: options?.refetchOnWindowFocus ?? false,
    staleTime: options?.staleTime,
  });

  return {
    ...unwrapPaginatedResponseDataAs(data, refetch, 'uncategorizedDocs'),
    ...rest,
  };
};
